import { Route, Routes } from "react-router-dom";
import AdminActionLogs from "../pages/dashboardPage/adminActionLogs/AdminActionLogs";
import RoomInformationEfficiency from "../pages/dashboardPage/adminOptions/roomInformationEfficiency/RoomInformationEfficiency";

const LogsNavigator = () => {
  return (
    <Routes>
      <Route path="/show-admin-action-logs" element={<AdminActionLogs />} />
      <Route
        path="/room-information-efficiency"
        element={<RoomInformationEfficiency />}
      />
      <Route path="*" element={<AdminActionLogs />} />
    </Routes>
  );
};

export default LogsNavigator;
